import axios from 'axios';

const auth = axios.create({
  baseURL: process.env.VUE_APP_KPN_AUTH_URI,
});

export default auth;
